<template>
    <div class="remind-wrapper">
        <div class="userAdd_man">
            <el-form ref="ruleForm" label-width="auto" :model="state.form" :rules="rules" class="userFrom">
                <el-form-item :label="t('attendance.viewDuration')" prop="duration" style="margin-top: 20px;">
                    <el-input-number v-model="state.form.duration" :min="5" style="margin-right: 10px;" />{{ t('attendance.seconds') }}
                </el-form-item>
                <el-form-item :label="t('attendance.craneRemind')" prop="content">
                    <WangEditor ref="WangEditor_remind" @change="valueChange" />
                </el-form-item>
                <el-form-item :label="t('attendance.excavatorRemind')" prop="content2">
                    <WangEditor ref="WangEditor_remind2" @change="valueChange2" />
                </el-form-item>
            </el-form>
        </div>
        <div class="dialog-footer">
            <el-button @click="reset">{{ t('common.reset') }}</el-button>
            <el-button type="primary" @click="submit">
                {{ t('common.confirm') }}
            </el-button>
        </div>
    </div>
</template>

<script setup>
import {
    onMounted,
    reactive,
    ref,
    nextTick,
    defineEmits,
    defineProps,
    defineExpose,
    toRaw
} from "vue";
import { ElMessage } from "element-plus";
import WangEditor  from "@/components/wang-editor"
import { detailApi, saveApi } from '@/api/attendance/remind'
import { useAttendancePageI18n, t } from '@/composables/useAttendancePageI18n.js';

const emit = defineEmits([]);
const WangEditor_remind = ref(null)
const WangEditor_remind2 = ref(null)

const state = reactive({
    dialogVisible: false,
    form: {
        "id": 1,
        "content": "",
        "content2": "",
        "duration": 15,
    }
});

const buildRules = () => ({
    content: [
        { required: true, message: t('attendance.enterCraneRemind'), trigger: "blur" },
    ],
    content2: [
        { required: true, message: t('attendance.enterExcavatorRemind'), trigger: "blur" },
    ],
    duration: [
        { required: true, message: t('attendance.enterViewDuration'), trigger: "blur" },
    ],
});

const rules = reactive(buildRules());

const applyLabels = () => {
    Object.assign(rules, buildRules());
};

useAttendancePageI18n(applyLabels);

const getRemind = () => {
    const params = JSON.stringify({
        id: 1,
        type: 4
    })
    detailApi(params).then(res => {
        if(res?.code === 200 && res.data) {
            state.form = {
                id: res.data.id ?? 1,
                content: res.data.content ?? '',
                content2: res.data.content2 ?? '',
                duration: res.data.duration ?? 15,
            }
            nextTick(() => {
                WangEditor_remind.value?.setValue(state.form.content)
                WangEditor_remind2.value?.setValue(state.form.content2)
            })
        }
    })
}

const valueChange = (html) => {
    state.form.content = html
}

const valueChange2 = (html) => {
    state.form.content2 = html
}

const ruleForm = ref(null)
const submit = () => {
    ruleForm.value.validate((valid) => {
        if (valid) {
            const params = JSON.stringify(toRaw(state.form))
            saveApi(params).then(res => {
                if(res?.code === 200) {
                    ElMessage.success(t('common.success'))
                }
            })
        } else {
            return false;
        }
    });
};

const reset = () => {
    state.form = {
        "id": 1,
        "content": "",
        "content2": "",
        "duration": 15,
    }
    WangEditor_remind.value.setValue('')
    WangEditor_remind2.value.setValue('')
}

onMounted(() => {
    try {
        applyLabels();
        getRemind()
    } catch (error) {

    }
});

</script>

<style lang="less" scoped>
.remind-wrapper {

    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.userAdd_man {
    width: 70%;
    min-height: 200px;
    max-height: 600px;
    overflow: auto;
    padding: 0 30px;

    ::v-deep .editor-content {
        max-height: 300px !important;
    }
}

.userFrom {
    width: 100%;
}

.el-form-item {
    margin-bottom: 0;
}

.tree_man {
    padding: 0 30px;
}
</style>
